<template>
  <div>
    <!--<a href="javascript:;" class="create-game" @click="createStory">{{configText.createNewStory}}</a>-->
  </div>
</template>

<script>
  import store from '../store/store'
  import configText from '../config/ConfigText'
  import {ComponentName, Methods} from '../const/common'

  export default {
    name: "create-story",
    data(){
      return {
        configText:configText
      }
    },
    store,
    methods: {
      createStory() {
        Methods.cutComponent('all', false);
        Methods.cutComponent([ComponentName.PUTTERN], true);
        store.state.nextPageHeaderConf['pattern'] =  {
          backPage: ComponentName.STORYS_LIST,
          backNote: '作品管理'
        }
        Methods.checkChapterHash(1);

      }
    }
  }
</script>

<style scoped>
  @import "../style/css/my_games.css";
</style>



// WEBPACK FOOTER //
// src/components/create_story_btn.vue